import { render } from "./Manual.vue?vue&type=template&id=1ae95153&scoped=true&ts=true"
import script from "./manualHelper.ts?vue&type=script&lang=ts"
export * from "./manualHelper.ts?vue&type=script&lang=ts"

import "./Manual.vue?vue&type=style&index=0&id=1ae95153&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae95153"]])

export default __exports__